class Empty {
    static path = 'values/empty';

    constructor(mutator){
        this.title = 'Empty';
        this.addOutput("empty / null", "");
        this.bgcolor = '#bfb5b2';
        this.desc = 'An empty / null value';
    }

}

module.exports = Empty
